import { render, staticRenderFns } from "./footer.vue?vue&type=template&id=dc1a1452&scoped=true"
import script from "./footer.vue?vue&type=script&setup=true&lang=js"
export * from "./footer.vue?vue&type=script&setup=true&lang=js"
import style0 from "./footer.vue?vue&type=style&index=0&id=dc1a1452&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc1a1452",
  null
  
)

export default component.exports